// extracted by mini-css-extract-plugin
module.exports = {"helpicon":"helpIcon_helpicon__14VNF"};